<svelte:window on:beforeunload={beforeUnload} />

<script>
  import { getContext } from 'svelte'

  const platform = getContext('platform')
  const notification = platform.api.core.store('jolojo.notification')
  const notificationToRemove = platform.api.core.store('jolojo.notificationToRemove')
  const uploadedImages = platform.api.core.store('jolojo.uploadedImages')

  export let files = []

  let imagesUploading = []

  function beforeUnload (e) {
    if (imagesUploading.length) {
      e.preventDefault()
      e.returnValue = 'Images are still uploading'
      return 'Images are still uploading'
    }
  }

  $: if (files.length) {
    // files has changed so check what type of file it is
    // check the latest added file to the queue
    const currentFile = files.at(-1)
    switch (currentFile.type) {
      case 'product':
        uploadProduct(currentFile)
        break
    }
  }

  async function uploadProduct (product) {
    $uploadedImages = []
    const notificationId = platform.api.core.uuid()
    const uploadingImages = {
      id: notificationId,
      type: 'warning',
      message: `Images for ${product.productName} uploading...`,
      notDismissable: true,
      icon: 'loading',
    }

    try {
      $notification = uploadingImages

      imagesUploading = [...imagesUploading, product.file]

      await platform.api.cms.files.upload(product.file, product.uploadPath)

      imagesUploading = imagesUploading.filter(f => f !== product.file)

      $notificationToRemove = uploadingImages

      // remove uploaded
      $notification = { // eslint-disable-line
        type: 'success',
        message: `Images for ${product.productName} have been uploaded`,
      }
    } catch (err) {
      console.error(err)
      $notification = { // eslint-disable-line
        type: 'error',
        message: `Could not upload images`,
      }
      $notificationToRemove = uploadingImages
      return
    }

    let i = 0
    for (const file of product.file) {
      try {
        await platform.api.ecom.productImages.create({
          productId: product.id,
          filename: file.name,
          sortIndex: i,
        })
      } catch (err) {
        console.error(err)
      }
      i++
    }

    $uploadedImages = [...$uploadedImages, uploadingImages]
  }
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>